import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const Clubs = () => {
    useEffect(() => {
        document.title = 'Clubs -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Clubs </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Activities</li>
                            <li>|</li>
                            <li> Clubs </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                     <div className="col-lg-12">
                        <p>We are aware of this fact that many reputed universities in India and abroad look for a resume that is about more than just academics. They look beyond the grades and marks. How accomplished a prospective student is, is judged on an all round criterion. Skills and activities are thoroughly examined. We believe that this awareness must be made widespread, especially for students aspiring to study abroad and even generally, it is better to be versatile. Involving children in extracurricular activities will keep them active and energetic. It will get them out of the sedentary routine they have these days. It makes them enthusiastic and chirpy too!</p>
                        <p>The integration of work and study is the key element in Sacred Heart School ,Ballia. All the students are obliged to gain practical experience in the course of their academic education. The concept of Clubs is seen as an opportunity for adaptation to life in the group, forming good life long habits and cultivating a voluntaristic spirit. Club activities supplement academics and give the students practical training which they require in day to day life. In the school various club activities are organized giving an opportunity to the students to display their talent.</p>
                        <p> The wide spectrum of literary activities undertaken by the Literary Club includes book discussions, review writing competitions, literary quizzes, elocution competitions, workshops, essay writing competitions, recitation competitions.</p>  
                     </div>
                </div>
                <div className="row sports"> 
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club1.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club1.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                            <p>English Literary Club</p>
                         </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club2.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club2.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                            <p>Green Club</p>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club3.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club3.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                            <p>Quest Club</p>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club4.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club4.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                            <p>Sports Club</p>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club5.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club5.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                            <p>Music Club</p>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club6.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club6.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                            <p>Performing Arts Club</p>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club7.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/club7.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                            <p>Ramanujan Club</p>
                    </a>
                </LazyLoad>
                </div> 
            </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Clubs